/** fonts: custom (brand) fonts — the Fonts tab on Apps and the font picker in app settings. Arabic is a draft for native review. */
const en = {
  "tab": "Fonts",
  "intro": "Upload your brand fonts (TTF or OTF) and pick one in any app's settings. Players download the font with the app.",
  "upload": "Upload fonts",
  "uploading": "Uploading…",
  "search": "Search fonts",
  "sample": "The quick brown fox",
  "name": "Font name",
  "rename": "Rename",
  "delete": "Delete",
  "usedBy": "used by {n} app | used by {n} apps",
  "unused": "not used yet",
  "loading": "Loading fonts…",
  "noMatch": "No fonts match your search.",
  "empty": "No custom fonts yet",
  "emptyHint": "Add the TTF or OTF files of your brand fonts. Web fonts (WOFF/WOFF2) can't be used by players.",
  "tooLarge": "{name} is larger than {mb} MB.",
  "added": "Added {list} | Added {list}",
  "deleted": "Deleted {name}",
  "deleteAsk": "Delete the font “{name}”?",
  "deleteUsed": "Delete the font “{name}”? {n} app uses it and will switch to the player's own font. | Delete the font “{name}”? {n} apps use it and will switch to the player's own font.",
  "field": "Font",
  "default": "Player font (default)",
  "manage": "Manage fonts",
  "uploadOne": "Upload a font",
};
const ar: typeof en = {
  "tab": "الخطوط",
  "intro": "ارفع خطوط علامتك التجارية (TTF أو OTF) واختر أحدها في إعدادات أي تطبيق. تُنزّل الشاشات الخط مع التطبيق.",
  "upload": "رفع خطوط",
  "uploading": "جارٍ الرفع…",
  "search": "ابحث في الخطوط",
  "sample": "نص تجريبي بالخط",
  "name": "اسم الخط",
  "rename": "إعادة تسمية",
  "delete": "حذف",
  "usedBy": "لا يستخدمه أي تطبيق | يستخدمه تطبيق واحد | يستخدمه تطبيقان | يستخدمه {n} تطبيقات | يستخدمه {n} تطبيقًا | يستخدمه {n} تطبيق",
  "unused": "غير مستخدم بعد",
  "loading": "جارٍ تحميل الخطوط…",
  "noMatch": "لا توجد خطوط تطابق البحث.",
  "empty": "لا توجد خطوط مخصصة بعد",
  "emptyHint": "أضف ملفات TTF أو OTF لخطوط علامتك. لا يمكن للشاشات استخدام خطوط الويب (WOFF/WOFF2).",
  "tooLarge": "حجم {name} أكبر من {mb} م.ب.",
  "added": "تمت إضافة {list} | تمت إضافة {list}",
  "deleted": "تم حذف {name}",
  "deleteAsk": "حذف الخط «{name}»؟",
  "deleteUsed": "حذف الخط «{name}»؟ ستستخدم التطبيقات التي تعتمد عليه ({n}) خط الشاشة الافتراضي.",
  "field": "الخط",
  "default": "خط الشاشة (افتراضي)",
  "manage": "إدارة الخطوط",
  "uploadOne": "رفع خط",
};
export default { en, ar };
